module.exports = __webpack_public_path__ + "img/k6.1dcb6da9.jpg";